<h1 mat-dialog-title [translate]="'UI.Settings'"></h1>

<form (ngSubmit)="onSubmit(form.value)">
  <mat-dialog-content class="full-width">
    @if (isFormSubmitted || (isLoading$ | async) === false) {
      @if (form && formSections.length > 0) {
        @for (section of formSections; track section.key) {
          <section class="section cf-flex-row cf-flex-column-xs cf-flex-column-sm" [ngClass]="{ border: $index > 0 }">
            <h2 class="cf-flex-20-percent">{{ section.label | translate }}</h2>
            <div class="cf-flex-80-percent cf-flex-row cf-flex-wrap cf-justify-content-start cf-align-items-center">
              @for (input of section.inputs; track $index) {
                <app-form-control class="control cf-flex-33-percent" [input]="input" [formGroup]="form.get(section.key)"></app-form-control>
              }
            </div>
          </section>
        }
      }
    } @else {
      <div class="spinner cf-flex-1 cf-flex-column cf-justify-content-center cf-align-items-center">
        <app-spinner></app-spinner>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button type="button" mat-button (click)="onCancel()" [disabled]="isLoading$ | async">
      <span>{{ 'UI.Cancel' | translate | uppercase }}</span>
    </button>
    <button type="submit" mat-raised-button class="primary-button" [disabled]="!form.valid || (isLoading$ | async)">
      <span>{{ 'UI.Save' | translate | uppercase }}</span>
    </button>
  </mat-dialog-actions>
</form>
